import { api } from "./api";

const basePath = "/history";

export const historyService = {
  list(params) {
    return api.get(`${basePath}/`, { params });
  },

  create(payload) {
    return api.post(`${basePath}/`, payload);
  },

  filter(params) {
    return api.get("/historicFilter", { params });
  },
};

export default historyService;
